export enum PersonalDetailsFormField {
  Address = 'address',
  EmailAddress = 'emailAddress',
  FirstName = 'firstName',
  LastName = 'lastName',
  PrivacyPolicy = 'privacyPolicy',
  TelephoneNumber = 'telephoneNumber',
  IpsAddress = 'ipsAddress',
}
